import { Injectable, Inject, EventEmitter } from "@angular/core";
import { throwError } from "rxjs/internal/observable/throwError";
import { ServerHubSignalR } from "./serverHub.signalR";

@Injectable({
  providedIn: 'root'
})
export class ServerHubService {

  public constructor(
    protected serverHubSignalR: ServerHubSignalR
  ) {

  }

  private handlers: ((...args: any[]) => void)[] = [];

  public addHandler(methodName: string, handlerMethod: (...args: any[]) => void) {
    this.handlers[methodName] = handlerMethod;

    this.serverHubSignalR.registerHandler(methodName, (...args) => handlerMethod.apply(this, args));
  }

  protected handleError(error: Response) {
    return throwError(error.statusText);
  }

  public setupCurrentAccountChangedNotify(notify: EventEmitter<any>) {
      this.serverHubSignalR.setupCurrentAccountChangedNotify(notify);
  }

}
